export function isTabletOrPhone() {
    return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) || isMobile();
}

export function forceMobile() {
    return document.location.host.includes('local') && document.location.href.includes('mobile');
}

export default function isMobile() {
    return (window && window.innerWidth < 768) || forceMobile();
}
